import React from 'react';
import PropTypes from 'prop-types';

import { Container, Section, Row, Column, Group } from 'components/core/Page';
import { H2, Text } from 'components/core/Typography';

import './StatePageLargestEmployers.scss';

export default function StatePageLargestEmployers({ state, largestEmployers }) {
	return (
		<div className="state-page-largest-employers">
			<Container className="largest-employers-container">
				<div className="largest-employers-content">
					<Section>
						<H2
							size="medium"
							className="state-page-title"
						>
							Who are {state}'s Largest Employers?
						</H2>
					</Section>
					<Section>
						<Group>
							<Row className="largest-employers-row">
								<Column
									large={4}
									className="employer-column employer-subtitle"
								>
									<Text
										weight="bold"
										size="small"
										color="darkGray"
										className="largest-employers-subtitle"
									>
										EMPLOYER
									</Text>
								</Column>
								<Column
									large={4}
									className="employees-column"
								>
									<Text
										weight="bold"
										size="small"
										color="darkGray"
										className="largest-employers-subtitle"
									>
										NUMBER OF EMPLOYEES
									</Text>
								</Column>
							</Row>
						</Group>
						{largestEmployers.employers.map(
							({ employer, employees }) => (
								<Group key={employer}>
									<Row className="largest-employers-row">
										<Column
											large={4}
											className="employer-column"
										>
											<Text
												size="small"
												className="employer"
											>
												{employer}
											</Text>
										</Column>
										<Column
											large={4}
											className="employees-column"
										>
											<Text
												color="red"
												size="small"
												className="employees-number"
											>
												{employees}
											</Text>
										</Column>
									</Row>
								</Group>
							),
						)}
					</Section>
				</div>
			</Container>
		</div>
	);
}

StatePageLargestEmployers.propTypes = {
	state: PropTypes.string.isRequired,
	largestEmployers: PropTypes.shape({
		employers: PropTypes.arrayOf(
			PropTypes.shape({
				employer: PropTypes.string,
				employees: PropTypes.string,
			}),
		).isRequired,
	}).isRequired,
};
